var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Slider } from "@mantine/core";
import classes from './Scale.module.scss';
export const Sentiment = {
    Positive: 'Positive',
    Neutral: 'Neutral',
    Negative: 'Negative',
};
export const SentimentSliderValue = {
    [Sentiment.Positive]: 2,
    [Sentiment.Neutral]: 50,
    [Sentiment.Negative]: 98,
};
export const SentimentColor = {
    [Sentiment.Positive]: 'teal.6',
    [Sentiment.Neutral]: 'yellow.6',
    [Sentiment.Negative]: 'red.7',
};
const Scale = (_a) => {
    var { sentiment } = _a, rest = __rest(_a, ["sentiment"]);
    const defaultValue = SentimentSliderValue[sentiment];
    return (_jsx(Slider, Object.assign({ size: "sm" }, rest, { disabled: true, defaultValue: defaultValue, showLabelOnHover: false, label: null, marks: [
            { value: SentimentSliderValue[Sentiment.Positive] },
            { value: SentimentSliderValue[Sentiment.Neutral] },
            { value: SentimentSliderValue[Sentiment.Negative] },
        ], classNames: classes })));
};
export default Scale;
